import { DrgResponseDto } from 'src/contracts/drgResponseDto';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { isEmpty } from 'src/common/arrayUtil';

export function getDiagnosesFromCalculationResult(drgResponseDtos: DrgResponseDto[]): DiagnosisCode[] {
  const codes: DiagnosisCode[] = [];
  if (isEmpty(drgResponseDtos)) {
    return codes;
  }

  for( let i=0; i<drgResponseDtos.length; i++) {
    const drgResponse = drgResponseDtos[i];

    if (drgResponse.diagnoses_results) {
      for (let j= 0; j < drgResponse.diagnoses_results.length; j++) {
        const drgDiagnosisFlags = drgResponse.diagnoses_results[j];
        const drgDiagnosisDescription = drgResponse?.diagnoses?.find(dxDesc => dxDesc.value == drgDiagnosisFlags.code);
        const qualityFlags = [];
        if (drgDiagnosisFlags?.hac_flag) {
          qualityFlags.push('HAC');
        }

        if(!codes.some(code => code.code == drgDiagnosisFlags.code)) {
          codes.push({
            code: drgDiagnosisFlags.code,
            description: drgDiagnosisDescription?.medium_description || drgDiagnosisDescription?.short_description,
            pdx: codes.length == 0, // pdx if first in the list
            drgModifier: drgDiagnosisFlags ? drgDiagnosisFlags.mcc_flag ? ['MCC'] : drgDiagnosisFlags.cc_flag ? ['CC'] : []: [],
            present_on_admission: drgDiagnosisFlags && drgDiagnosisFlags.poa,
            id: j,
            quality: qualityFlags,
            risk: drgResponse?.elixhauser_code_results?.find(elix => elix.code == drgDiagnosisFlags.code) ? ['ELIX'] : [],
            action: undefined
          });
        }
      }
    }
  }

  return codes;
}